module.exports = __webpack_public_path__ + "img/content5.a7ee46c8.png";